var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{class:['label', ("label-production-panel-type-" + _vm.type)]},[_vm._v(_vm._s(_vm.formatLookupName(_vm.type, _vm.ProductionPanelTypeLookup)))])])}
var staticRenderFns = []

export { render, staticRenderFns }